import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "gd_token";

export const api = axios.create({ baseURL: `${BASE}/api/gd` });
export const web = axios.create({ baseURL: `${BASE}/api/web` });
export const pay = axios.create({ baseURL: `${BASE}/api/payments` });
export const calendarUrl = (token) => `${BASE}/api/web/calendar/${token}.ics`;
export const recruiterCalendarUrl = (token) => `${BASE}/api/web/recruiter-calendar/${token}.ics`;
export const playFileUrl = (teamId, play) =>
  play?.file_id
    ? `${BASE}/api/web/play-files/${play.file_id}/stream`
    : `${BASE}/api/web/teams/${teamId}/plays/${play?.id}/file?token=${localStorage.getItem(TOKEN_KEY) ?? ""}`;

const withToken = (config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
};
api.interceptors.request.use(withToken);
web.interceptors.request.use(withToken);
pay.interceptors.request.use(withToken);

export const webUrl = (path) => (path ? `${BASE}${path}` : null);
/** Website-only photo (uploaded by the player) wins over the app photo. App photos go through the website copy so
 * teammates, parents and recruiters can see them too (`v` = current app path, so a new photo replaces the old one). */
export const avatarSrc = (teamId, p) =>
  webUrl(p?.web_photo_url) ??
  (p?.id && (p.photo_path || p.has_app_photo)
    ? `${BASE}/api/web/player-photo/${p.player_id ?? p.id}?token=${localStorage.getItem(TOKEN_KEY) ?? ""}${teamId ? `&team_id=${teamId}` : ""}${p.photo_path ? `&v=${encodeURIComponent(p.photo_path)}` : ""}`
    : null);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d[0]?.msg ?? "Request failed";
  return e?.message ?? "Something went wrong";
};

export const toList = (d, keys = []) => {
  if (Array.isArray(d)) return d;
  for (const k of keys) if (Array.isArray(d?.[k])) return d[k];
  return [];
};
